// extracted by mini-css-extract-plugin
module.exports = {"top":"_32bbee5fda--top--nfdoh","close":"_32bbee5fda--close--wmWi1"};